import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import StarIcon from "@mui/icons-material/Star";
import {
    Avatar,
    Box,
    Button,
    Card,
    Grid,
    Link,
    Stack,
    Tooltip,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { DetailBundling } from "../../constants/types";
import { useDetailBarangModal } from "../../context/detailBarangModalContext";
import { useTransaksi } from "../../context/transaksiContext";
import avatarAlt from "../../utils/avatarAlt";
import toRibuan from "../../utils/toRibuan";
import toRupiah from "../../utils/toRupiah";
import truncate from "../../utils/truncate";
import "./CardBarang.css";

interface ICardBarangProps {
    id: number;
    namaBarang: string;
    namaKategori: string;
    deskripsi?: string;
    harga: number;
    url: string;
    sku: string;
    jumlahStok: number;
    detailBundling: DetailBundling[]
    favorite: number;
    hpp: {
        id: number;
        faktur: string;
        hargaBeli: number;
        jumlah: number;
    }[];
    multipleHarga: {
        id: number;
        harga: number;
        keterangan: string | null;
    }[];
    keteranganItem: string | null;
    hargaSatuan: string;
}

const CardBarang = ({
    id,
    namaBarang,
    namaKategori,
    deskripsi,
    harga,
    url,
    sku,
    jumlahStok,
    detailBundling,
    favorite,
    hpp,
    multipleHarga,
    keteranganItem,
    hargaSatuan,
}: ICardBarangProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.between("xs", "sm"));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const { addToCart, cart } = useTransaksi();
    const { openModalDetailBarang } = useDetailBarangModal();

    return (
        <React.Fragment>
            <Card
                variant="outlined"
                sx={{
                    marginBottom: 1,
                    padding: 2,
                }}
            >
                <Box
                    display="grid"
                    gridTemplateColumns="1fr auto"
                    rowGap={isPhoneScreen ? 1 : 3}
                    sx={{
                        alignItems: { xs: "stretch", sm: "center" },
                        justifyContent: {
                            xs: "space-between",
                            sm: "space-between",
                        },
                    }}
                >
                    <Stack
                        direction={{ xs: "row-reverse", sm: "row" }}
                        sx={{
                            whiteSpace: "nowrap",
                            // overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                        spacing={2}
                    >
                        <Box sx={{ marginBottom: favorite > 0 ? -5 : 0 }}>
                            <Link
                                onClick={() =>
                                    openModalDetailBarang(
                                        namaBarang,
                                        url,
                                        deskripsi,
                                    )
                                }
                                color="#000000"
                                underline="none"
                                sx={{ cursor: "pointer" }}
                            >
                                <Avatar
                                    sx={{
                                        backgroundColor: "primary.main",
                                        width: {
                                            xs: 60,
                                            sm: 60,
                                            md: 70,
                                            lg: 60,
                                            xl: 80,
                                        },
                                        height: {
                                            xs: 60,
                                            sm: 60,
                                            md: 90,
                                            lg: 70,
                                            xl: 90,
                                        },
                                    }}
                                    variant="rounded"
                                    alt={namaBarang}
                                    src={url}
                                >
                                    {avatarAlt(namaBarang)}
                                </Avatar>
                            </Link>
                            {favorite > 0 && (
                                <StarIcon
                                    sx={{
                                        width: isSmallScreen ? 32 : undefined,
                                        height: isSmallScreen ? 32 : undefined,
                                        position: "relative",
                                        zIndex: 2,
                                        bottom: {
                                            xl: 105,
                                            lg: 86,
                                            sm: 70,
                                            xs: 70,
                                        },
                                        left: "70%",
                                        border: 1,
                                        borderColor: "#e7e5e4",
                                        borderRadius: "50%",
                                        padding: isPhoneScreen ? 0.5 : 0.25,
                                        color: "#fbbf24",
                                        bgcolor: "#FFFFFF",
                                    }}
                                    fontSize="large"
                                />
                            )}
                        </Box>
                        <Grid container>
                            <Grid item>
                                <Link
                                    onClick={() =>
                                        openModalDetailBarang(
                                            namaBarang,
                                            url,
                                            deskripsi,
                                        )
                                    }
                                    color="#000000"
                                    underline="none"
                                    sx={{ cursor: "pointer" }}
                                >
                                    <Tooltip title={namaBarang}>
                                        <Typography
                                            fontSize={isPhoneScreen ? 14 : 16}
                                            fontWeight="bold"
                                        >
                                            {truncate(namaBarang, 20)}
                                        </Typography>
                                    </Tooltip>
                                    {deskripsi ? (
                                        <Tooltip title={deskripsi}>
                                            <Typography
                                                fontSize={12}
                                                color="#76747C"
                                            >
                                                {truncate(deskripsi, 30)}
                                            </Typography>
                                        </Tooltip>
                                    ) : undefined}
                                    <Typography
                                        mt={isPhoneScreen ? undefined : 1}
                                        fontSize={12}
                                        color={
                                            (jumlahStok < 5 &&
                                                jumlahStok !== null) ||
                                            !detailBundling.every(
                                                (item) =>
                                                    item.stok === null ||
                                                    item.stok > 0,
                                            )
                                                ? "#ef4444"
                                                : "#76747C"
                                        }
                                        fontWeight={
                                            (jumlahStok < 5 &&
                                                jumlahStok !== null) ||
                                            !detailBundling.every(
                                                (item) =>
                                                    item.stok === null ||
                                                    item.stok > 0,
                                            )
                                                ? 700
                                                : 600
                                        }
                                    >
                                        {detailBundling.length > 0
                                            ? detailBundling.every(
                                                  (item) =>
                                                      item.stok === null ||
                                                      item.stok > 0,
                                              )
                                                ? "Otomatis"
                                                : "Ada barang yang habis"
                                            : jumlahStok === null
                                            ? "Tanpa stok"
                                            : jumlahStok > 5
                                            ? "Tersedia " +
                                              toRibuan(jumlahStok) +
                                              " barang"
                                            : jumlahStok <= 5 && jumlahStok > 0
                                            ? "Barang tersisa " +
                                              toRibuan(jumlahStok)
                                            : "Barang telah habis"}
                                    </Typography>
                                    {multipleHarga.length > 0 ? (
                                        <Typography
                                            variant="subtitle2"
                                            color="#76747C"
                                            fontWeight="bold"
                                        >
                                            {toRupiah(
                                                Number(multipleHarga[0].harga),
                                            )}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            variant="subtitle2"
                                            color="#76747C"
                                            fontWeight="bold"
                                        >
                                            {toRupiah(harga)}
                                        </Typography>
                                    )}
                                </Link>
                            </Grid>
                        </Grid>
                    </Stack>
                    {/* <Button
                        disabled={
                            cart.findIndex((c) => c.id === id) >= 0 ||
                            (jumlahStok <= 0 && jumlahStok !== null) ||
                            !detailBundling.every(
                                (item) => item.stok === null || item.stok > 0,
                            )
                        }
                        data-testid="button-pesan"
                        variant="contained"
                        onClick={() =>
                            addToCart({
                                id,
                                namaBarang,
                                namaKategori,
                                harga:
                                    multipleHarga.length > 0
                                        ? Number(multipleHarga[0].harga)
                                        : harga,
                                url,
                                qty: 1,
                                sku,
                                jumlahStok,
                                detailBundling,
                                hpp,
                                faktur: [],
                                multipleHarga,
                                keteranganItem,
                            })
                        }
                        startIcon={
                            cart.findIndex((c) => c.id === id) >= 0 ? (
                                <ShoppingCartIcon />
                            ) : (
                                <AddShoppingCartIcon />
                            )
                        }
                        sx={{
                            gridColumn: isPhoneScreen ? "1 / 3" : "unset",
                        }}
                    >
                        {cart.findIndex((c) => c.id === id) >= 0
                            ? "Di Keranjang"
                            : (jumlahStok <= 0 && jumlahStok !== null) ||
                              !detailBundling.every(
                                  (item) => item.stok === null || item.stok > 0,
                              )
                            ? "Stok Habis"
                            : "Pesan"}
                    </Button> */}

                    <Button
                        disabled={
                            cart.findIndex((c) => c.id === id) >= 0 ||
                            (jumlahStok <= 0 && jumlahStok !== null) ||
                            !detailBundling.every(
                                (item) => item.stok === null || item.stok > 0,
                            )
                        }
                        variant="contained"
                        onClick={() =>
                            addToCart({
                                id,
                                namaBarang,
                                namaKategori,
                                harga:
                                    multipleHarga.length > 0
                                        ? Number(multipleHarga[0].harga)
                                        : harga,
                                url,
                                qty: 1,
                                sku,
                                jumlahStok,
                                detailBundling,
                                hpp,
                                faktur: [],
                                multipleHarga,
                                keteranganItem,
                                hargaSatuan,
                            })
                        }
                        startIcon={
                            cart.findIndex((c) => c.id === id) >= 0 ? (
                                <ShoppingCartIcon />
                            ) : (jumlahStok <= 0 && jumlahStok !== null) ||
                            !detailBundling.every(
                                (item) => item.stok === null || item.stok > 0,
                            ) ? (
                                <RemoveShoppingCartIcon />
                            ) : (
                                <ShoppingCartCheckoutIcon />
                            )
                        }
                        sx={{
                            gridColumn: isPhoneScreen ? "1 / 3" : "unset",
                        }}
                    >
                        {cart.findIndex((c) => c.id === id) >= 0
                            ? "Di Keranjang"
                            : (jumlahStok <= 0 && jumlahStok !== null) ||
                            !detailBundling.every(
                                (item) => item.stok === null || item.stok > 0,
                            )
                            ? "Stok Habis"
                            : "Pesan"}
                    </Button>
                </Box>
            </Card>
        </React.Fragment>
    );
};

export default CardBarang;
